module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.searchTearm),
      expression: "searchTearm",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "search__search-input",
    attrs: {
      "type": "search",
      "name": "song search",
      "placeholder": _vm.getSearchTearm
    },
    domProps: {
      "value": (_vm.searchTearm)
    },
    on: {
      "change": function($event) {
        _vm.searchTearm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "icon-magnifying_glass",
    attrs: {
      "type": "submit",
      "name": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-types"
  }, [_vm._v("\n      Looking for:\n      "), _c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "search-type",
      "value": "album"
    },
    domProps: {
      "checked": _vm.$store.state.searchType === 'album'
    },
    on: {
      "change": _vm.setSearchType
    }
  }), _vm._v(" "), _c('span', [_vm._v("Albums")])]), _vm._v("\n      or\n      "), _c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "search-type",
      "value": "artist"
    },
    domProps: {
      "checked": _vm.$store.state.searchType === 'artist'
    },
    on: {
      "change": _vm.setSearchType
    }
  }), _vm._v(" "), _c('span', [_vm._v("Artists")])])])]), _vm._v(" "), _c('search-results')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14bfe3ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 58
// module chunks = 1